
<template>
  <div class="quality-management">
    <div class="headLine">
      <img src="../leftAngle.png" alt="返回首页" @click="backIndex" />
      药品管理
    </div>
    <div class="object-wrapper">
      <div class="btn-up">
        <button class="btn"
                @click="record">药品进出库记录</button>
      </div>
      <div class="btn-down">
        <button class="btn"
                @click="detail">药品信息</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return{
      popstateLock: 0,//是否监听物理返回键
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate()
      }else{
        this.removePopstate()
      }
    }
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
  },
  destroyed(){
    this.removePopstate()
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    fixedAssets () {
      // 去扫码页面
      this.$router.push({ name: 'numbersearch', query: {type: 2} });
    },
    nonFixedAssets () {
      // 直接去填写
      this.$router.push({ name: 'createorder', query: { isFixedAssets: false } })
    },
    // 返回首页
    backIndex() {
      this.$router.replace({ name: 'hyPage' });
    },
    //药品进出库记录
    record() {
      this.$router.replace({ name: 'medicineRecord' });
    },
    //药品信息
    detail() {
      this.$router.replace({ name: 'medicineMessageRecord' });
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/style/global.scss";
.quality-management {
  height: 100%;
  padding: 0;
  position: relative;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #fff;
    height: 50px;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    font-size: 16px;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  // background: #fff;
  .object-wrapper {
    position: relative;
    display: block;
    text-align: center;
    button {
      width: 80%;
      height: 7rem;
      background-color: rgb(4, 206, 4);
      font-size: 1.8rem;
    }
    .btn-up {
      height: 50vh;
      border-bottom: 1px #efefef solid;
      position: relative;
      button {
        margin: calc((50vh - 7rem) / 2) 0;
      }
    }

    .btn-down {
      margin-top: 0;
      button {
        margin: calc((50vh - 7rem - 1px) / 2) 0;
        background-color: orange;
      }
    }
  }
}
</style>
